module.exports = __webpack_public_path__ + "img/iphone.58818f53.png";